/* =============================================================================
   pf-visit.js —— 访客埋点（2026-10-14）

   目标：多少人 / 什么人（设计师 or 游客）/ 停留多久 / 时段 / 实时在线，
        全部落**原始数据**（bridge 的 visit_events），日后可换任意口径分析。

   设计取舍：
     · 访客 ID 只存浏览器本地（localStorage），不采集任何身份信息；
       若该访客**早前**在设计台登记过邮箱（hdCreatorProfile_v1，同一份既存数据），
       才顺带带上邮箱 ⇒ 后台据此区分「设计师 / 游客」。除此之外不发任何个人数据。
     · 停留时长：页面不可见/关闭时用 navigator.sendBeacon 上报 leave（含本页毫秒），
       不阻塞卸载 ⇒ 数据可靠（fetch 在卸载时会被浏览器取消）。
     · 心跳 120s 且**仅页面可见时**发 —— 用于「实时在线」。VPS 只 1 核，刻意压低频率。
     · 上报失败一律静默吞掉：埋点绝不能影响店面体验。

   开关：URL 带 `?pfvisit=off` ⇒ 本次不埋点（自测用）。
   ============================================================================= */
(function () {
  'use strict';

  try { if (/(?:^|[?&])pfvisit=off(?:&|$)/.test(location.search)) return; } catch (e) { }

  var EP = 'https://bridge.highdeep.net/visit';
  var K_VID = 'hdVid_v1', K_SID = 'hdSession_v1', K_REF = 'hdRef_v1';
  var IDLE = 30 * 60 * 1000;      /* 30 分钟无活动 = 新会话 */
  var HB = 120 * 1000;            /* 心跳间隔 */
  var MAX_DWELL = 6 * 3600 * 1000;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) { } }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { } }

  function rid() {
    try {
      if (window.crypto && window.crypto.getRandomValues) {
        var a = new Uint8Array(9);
        window.crypto.getRandomValues(a);
        var s = '';
        for (var i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2);
        return s;
      }
    } catch (e) { }
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  /* 访客 ID：浏览器永久 */
  var vid = lsGet(K_VID);
  if (!vid) { vid = rid(); lsSet(K_VID, vid); }

  /* 会话 ID：30 分钟无活动即换新 */
  var now = Date.now(), sess = null;
  try { sess = JSON.parse(ssGet(K_SID) || 'null'); } catch (e) { }
  if (!sess || !sess.id || (now - (sess.t || 0)) > IDLE) sess = { id: rid(), t: now };
  sess.t = now;
  ssSet(K_SID, JSON.stringify(sess));

  /* 身份：只读既存的设计台登记信息（绝不在本文件新采集） */
  var email = '', isDesigner = 0;
  try {
    var p = JSON.parse(lsGet('hdCreatorProfile_v1') || 'null');
    if (p && p.email && String(p.email).indexOf('@') > 0) {
      email = String(p.email).trim().toLowerCase().slice(0, 120);
      isDesigner = 1;
    }
  } catch (e) { }

  function device() {
    try {
      var ua = navigator.userAgent || '';
      var m = /iPad|Tablet/i.test(ua) ? 'tablet' : (/Mobi|Android|iPhone/i.test(ua) ? 'mobile' : 'desktop');
      var b = /Edg\//.test(ua) ? 'Edge' : (/OPR\//.test(ua) ? 'Opera' : (/Chrome\//.test(ua) ? 'Chrome'
            : (/Safari\//.test(ua) ? 'Safari' : (/Firefox\//.test(ua) ? 'Firefox' : 'other'))));
      return m + ' / ' + b;
    } catch (e) { return 'unknown'; }
  }

  function tzName() {
    try { return String(Intl.DateTimeFormat().resolvedOptions().timeZone || '').slice(0, 40); } catch (e) { return ''; }
  }
  function langName() {
    try { return String(navigator.language || '').slice(0, 16); } catch (e) { return ''; }
  }

  /* 来源：只认**会话内首次落地**的来源，页内跳转不覆盖 */
  function source() {
    try {
      var s = ssGet(K_REF);
      if (s !== null && s !== '') return s;
      var r = '';
      try { r = document.referrer ? String(new URL(document.referrer).hostname) : ''; } catch (e) { r = ''; }
      if (!r) {
        try { r = String(new URL(location.href).searchParams.get('utm_source') || '(direct)'); } catch (e) { r = '(direct)'; }
      }
      r = String(r).slice(0, 120);
      ssSet(K_REF, r);
      return r;
    } catch (e) { return ''; }
  }

  function body(kind, extra) {
    var o = {
      vid: vid, sid: sess.id, kind: kind,
      path: String(location.pathname || '/').slice(0, 200),
      ref: source(), device: device(),
      isDesigner: isDesigner, email: email,
      /* 访客时区 / 语言：bridge 不在 Cloudflare 后面 ⇒ 服务端拿不到 cf-ipcountry，
         用浏览器时区当「地域」代理（不精确到城市，但足够看「什么人、从哪来」）。 */
      meta: { tz: tzName(), lang: langName() }
    };
    if (extra) for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) o[k] = extra[k]; }
    return JSON.stringify(o);
  }

  function send(kind, extra) {
    try {
      var b = body(kind, extra);
      /* leave 必须 sendBeacon：页面正在关闭，fetch 会被取消 */
      if (kind === 'leave' && navigator.sendBeacon) {
        try {
          if (navigator.sendBeacon(EP, new Blob([b], { type: 'application/json' }))) return;
        } catch (e) { }
      }
      fetch(EP, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: b, keepalive: (kind === 'leave'), credentials: 'omit'
      }).catch(function () { });
    } catch (e) { }
  }

  var t0 = Date.now();
  send('pv');

  /* 离开上报：只报一次；回到页面则重新计一段（只算「可见时长」） */
  var left = false;
  function leave() {
    if (left) return;
    left = true;
    var d = Date.now() - t0;
    if (d < 0) d = 0;
    if (d > MAX_DWELL) d = MAX_DWELL;
    send('leave', { dwellMs: d });
  }
  document.addEventListener('visibilitychange', function () {
    try {
      if (document.visibilityState === 'hidden') { leave(); }
      else { left = false; t0 = Date.now(); }
    } catch (e) { }
  });
  window.addEventListener('pagehide', leave);
  window.addEventListener('beforeunload', leave);

  /* 心跳：仅可见时 —— 「实时在线」的数据源 */
  try {
    setInterval(function () {
      try {
        if (document.visibilityState !== 'visible') return;
        sess.t = Date.now();
        ssSet(K_SID, JSON.stringify(sess));
        send('hb');
      } catch (e) { }
    }, HB);
  } catch (e) { }
})();
